import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { format } from 'date-fns';
import { CalendarIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import OrderTypes from '../../types/OrderTypes';
var DATES_COLUMN_TYPES = [ColumnTypes.DATE, ColumnTypes.CREATED_AT, ColumnTypes.UPDATED_AT];
var DATES_EDITABLE_COLUMN_TYPES = [ColumnTypes.DATE];

var getDate = function getDate(_ref) {
  var column = _ref.column,
      record = _ref.record,
      field = _ref.field;
  var date = null;

  switch (column.type) {
    case ColumnTypes.CREATED_AT:
      date = record.createdAt;
      break;

    case ColumnTypes.UPDATED_AT:
      date = record.updatedAt;
      break;

    case ColumnTypes.DATE:
      date = field.data.text || '';
      break;

    default:
      break;
  }

  return date;
};

export default function DatePlugin() {
  return [{
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      if (DATES_COLUMN_TYPES.includes(columnType)) {
        return React.createElement(CalendarIcon, null);
      }

      return next();
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      if (columnType === ColumnTypes.DATE) {
        return 'Date';
      }

      if (columnType === ColumnTypes.CREATED_AT) {
        return 'Created Time';
      }

      if (columnType === ColumnTypes.UPDATED_AT) {
        return 'Updated Time';
      }

      return next();
    },
    canEdit: function canEdit(columnType, database, next) {
      if (DATES_COLUMN_TYPES.includes(columnType)) {
        return DATES_EDITABLE_COLUMN_TYPES.includes(columnType);
      }

      return next();
    },
    canSort: function canSort(columnType, database, next) {
      if (!DATES_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return true;
    },
    getSortOptions: function getSortOptions(columnType, database, next) {
      var _ref2;

      if (!DATES_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return _ref2 = {}, _defineProperty(_ref2, OrderTypes.ASC, 'Earliest first'), _defineProperty(_ref2, OrderTypes.DESC, 'Latest first'), _ref2;
    },
    getSortStrategies: function getSortStrategies(columnType, database, next) {
      var _ref3;

      if (!DATES_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      var orderBy = function orderBy(order) {
        return function (recordA, recordB, columnKey) {
          var column = database.getColumn(columnKey);
          var fieldA = database.getField(recordA.key, columnKey);
          var fieldB = database.getField(recordB.key, columnKey);
          var dateA = getDate({
            field: fieldA,
            record: recordA,
            column: column
          });
          var dateB = getDate({
            field: fieldB,
            record: recordB,
            column: column
          });
          var aLowerThanB = dateA - dateB;
          return aLowerThanB * (order === OrderTypes.ASC ? 1 : -1);
        };
      };

      return _ref3 = {}, _defineProperty(_ref3, OrderTypes.ASC, orderBy(OrderTypes.ASC)), _defineProperty(_ref3, OrderTypes.DESC, orderBy(OrderTypes.DESC)), _ref3;
    },
    renderField: function renderField(_ref4, database, next) {
      var field = _ref4.field,
          record = _ref4.record,
          column = _ref4.column;

      if (!DATES_COLUMN_TYPES.includes(column.type)) {
        return next();
      }

      var date = getDate({
        field: field,
        record: record,
        column: column
      });
      var dateFormatted = format(date, 'MMM, D YYYY');
      var canEdit = DATES_EDITABLE_COLUMN_TYPES.includes(column.type);
      return React.createElement("div", {
        className: classNames('flexbox-grow height-full', 'padding-vertical-small padding-horizontal-normal', {
          pointer: canEdit
        })
      }, dateFormatted);
    },
    convertField: function convertField(source, destination, database, next) {
      if (!DATES_COLUMN_TYPES.includes(destination.column.type)) return next();
      var text = database.run('serializeField', source);
      return {
        text: text
      };
    },
    serializeField: function serializeField(_ref5, database, next) {
      var field = _ref5.field,
          record = _ref5.record,
          column = _ref5.column;
      if (!DATES_COLUMN_TYPES.includes(column.type)) return next();
      var date = getDate({
        field: field,
        record: record,
        column: column
      });
      return new Date(date).toISOString();
    }
  }];
}